@if (productPlan) {
  <panel width="450">
    <form>
      <h1>{{ 'company.product-plans.change-name' | translate }}</h1>
      <section>
        <custom-input [label]="'company.product-plans.name' | translate" [(value)]="updatedProductPlanName" [required]="true" maxlength="100" />
      </section>
      <section>
        <button confirm (click)="saveProductPlan()" [label]="'general.save' | translate"></button>
      </section>
    </form>
  </panel>
}
